import { Dispatch, SetStateAction } from "react";
import {
  IonLabel,
  IonSegment,
  IonSegmentButton,
  SegmentCustomEvent,
  SegmentValue,
} from "@ionic/react";
import { SegmentNameUnion } from "pages/RequestIndex/hooks";

type Segment = {
  label?: string;
  value: SegmentValue;
  count?: number;
};

export type Segments = Segment[];

export type SegmentProps = {
  segments: Segments;
  initialValue: SegmentValue;
  onSegmentChange: Dispatch<SetStateAction<SegmentNameUnion>>;
};

export function Segment(props: SegmentProps) {
  const { segments, initialValue, onSegmentChange } = props;

  function handleSegmentChange(e: SegmentCustomEvent) {
    const selectedSegment = e.detail.value as SegmentNameUnion;

    if (selectedSegment) {
      onSegmentChange(selectedSegment);
    }
  }

  return (
    <div className="mw-800">
      <IonSegment value={initialValue} onIonChange={handleSegmentChange}>
        {segments.map(({ label, value, count }) => (
          <IonSegmentButton key={value} color="primary" value={value}>
            <IonLabel>
              {label}
              <span css={{ marginLeft: 4 }}>({count || 0})</span>
            </IonLabel>
          </IonSegmentButton>
        ))}
      </IonSegment>
    </div>
  );
}
